module.exports = require("@mui/material/Button");